<p-dialog header="Expression" [(visible)]="displayAddExpression" (onHide)="expressionDialogClose()" [modal]="true"
    [responsive]="true" [style]="{ width: '25vw' }">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <label>Enter Expression <small>Example: (([Field1]+[Field2])/2)</small></label>
                <span class="text-input-prefix w-100">
                    <span class="prefix-area">=</span>
                    <textarea #expressionInput type="text" (keydown.enter)="$event.preventDefault()" [(ngModel)]="expressionText" pInputText placeholder="Enter Expression"></textarea>
                </span>

                <div *ngIf="expressionErrorMsg" class="p-invalid mb-1">
                    <small>{{ expressionErrorMsg }}</small>
                </div>
            </div>
            <div *ngIf="!viewOnly" class="p-col-6">
                <label>Available Operators</label>
                <p-listbox [options]="expressionOperators" [metaKeySelection]="false" (onChange)="selectTemplateField($event,'operator')" optionLabel="labelname" [filter]="true" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedType" class="available-field-list w-100" [listStyle]="{'height':'295px'}">
                    <ng-template let-type pTemplate="item">
                        <div class="type-item">
                            <div>{{type.labelname}}</div>
                        </div>
                    </ng-template>
                </p-listbox>
            </div>
            <div *ngIf="!viewOnly" class="p-col-6">
                <label>Available Fields</label>
                <p-listbox [options]="availableFieldsForExpression" [metaKeySelection]="false" (onChange)="selectTemplateField($event)" optionLabel="labelname" [filter]="true" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedType" class="available-field-list w-100" [listStyle]="{'height':'295px'}">
                    <ng-template let-type pTemplate="item">
                        <div class="type-item">
                            <div>{{type.labelname}}</div>
                        </div>
                    </ng-template>
                </p-listbox>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="expressionDialogClose()" label="Cancel" class="p-button-secondary"></button>
        <button *ngIf="!viewOnly" type="submit" pButton (click)="saveExpression()" label="Save"></button>
    </p-footer>
</p-dialog>
